
import React from 'react';
import { formatMarketCap, formatPercentChange } from '../utils/format-helpers';
import './stat-card.css';

function StatCard({ 
  label, 
  value, 
  change = null, 
  isLoading = false, 
  className = '',
  type = 'default',
  icon = null 
}) {
  if (isLoading) {
    return (
      <div className={`stat-card loading ${className}`}>
        <div className="stat-label skeleton"></div>
        <div className="stat-value skeleton large"></div>
        <div className="stat-change skeleton small"></div>
      </div>
    );
  }

  // Format value based on type
  const formatValue = (val) => {
    if (!val && val !== 0) return 'N/A';
    
    switch (type) {
      case 'currency':
        return formatMarketCap(val);
      case 'percentage':
        return formatPercentChange(val);
      case 'number':
        return typeof val === 'number' ? val.toLocaleString() : val;
      default:
        return val;
    }
  };

  // Determine change class
  const getChangeClass = () => {
    if (change === null || change === undefined) return '';
    const numChange = parseFloat(change);
    if (numChange > 0) return 'positive';
    if (numChange < 0) return 'negative';
    return 'neutral';
  };

  return (
    <div className={`stat-card ${className}`}>
      <div className="stat-header">
        {icon && <div className="stat-icon">{icon}</div>}
        <div className="stat-label">{label}</div>
      </div>
      
      <div className="stat-value">
        {formatValue(value)}
      </div>
      
      {change !== null && change !== undefined && (
        <div className={`stat-change ${getChangeClass()}`}>
          {formatPercentChange(change)}
        </div>
      )}
    </div>
  );
}

export default StatCard;
